<template>
    <div>
        <input type="file" @change="uploadPdf" class="d-none" accept="application/pdf">
        <div class="d-flex flex-column align-items-center">
            <b-button block class="ds-btn" type="button" @click="pickPdf" :disabled="isProcessing">
                Izvēlēties dokumentu (pdf)
            </b-button>
            <b-badge class="p-2" variant="primary">{{ pdfPath }}</b-badge>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        name: 'pdf-upload',
        props: {
            file: {
                type: String,
            },
        },
        data() {
            return {
                pdfPath: this.file,
                isProcessing: false,
            }
        },
        methods: {
            pickPdf() {
                this.$el.querySelector('input').click();
            },
            async uploadPdf(e) {
                const [pdf] = e.target.files;

                if (!pdf) {
                    return;
                }

                this.isProcessing = true;

                const formData = new FormData;
                formData.append('pdf', pdf);

                const {data: {pdfPath, success}} = await axios.post('/api/uploads/pdf', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                });

                if (!success) {
                    return alert('Kaut kas nogāja greizi.');
                }

                this.pdfPath = '/' + pdfPath;
                this.$emit('uploaded', {path: this.pdfPath, filename: pdf.name});

                this.isProcessing = false;
                e.target.value = '';
            },
        }
    }
</script>